import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, DateTime, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {DataService} from "../../../providers/data-service";
import {TAction} from "../../../app/enum";
import {CONFIG} from "../../../app/config";

import {SpotdayService} from "../../../providers/spotday-service";
import {SpotdayViewPage} from "../spotday-view/spotday-view";
import {WebstorOpenPage} from '../webstor-open/webstor-open';
import {SpotdayInfoPage} from '../spotday-info/spotday-info';
    


@Component({
    selector: 'page-spotday-list',
    templateUrl: 'spotday-list.html',
    providers: [SpotdayService]
})
export class SpotdayListPage {

    config: any;

    logado: any;

    etapa: number;
    flagstor: boolean;

    projetoLupa: any;
    spotdayLupa: number;
    spotdays: Array<any> = [];
    copydays: Array<any> = [];

    rootile: any;
    rootspot: any;

    @ViewChild(DateTime) iondate: DateTime;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public dataService: DataService,
                public spotdayService: SpotdayService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.flagstor = this.navParams.get('flagstor');

        this.rootile = this.navParams.get('rootile');
        this.rootspot = this.navParams.get('rootspot');

        this.spotdayLupa = this.util.dateHoje().getFullYear();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Spotday List', '/spotday-list');

        if (this.etapa == 0) this.spotdayLoad();

    }

    ionViewDidLoad() {

    }

    getTitle() {

        if (this.etapa == 0) return (this.flagstor ? 'Promotoria' : 'Eventos');

    }

    spotdayLoad() {

        let action = (this.flagstor ? TAction.acLoad : TAction.acList);
        let hotspotID = (this.flagstor && this.rootspot ? this.rootspot.Hotspots[0].HotspotID : 0);
        let profileID = (!this.flagstor && this.rootile ? this.rootile.Profile.ProfileID : 0);
        let projetoID = (this.projetoLupa && this.rootile ? this.projetoLupa.ProjetoID : 0);

        let loading = this.util.loadingDots();
        if (this.etapa == 0) loading.present();

        this.spotdayService.spotday(action, 0, hotspotID, profileID, projetoID)
            .finally(() => loading.dismiss())
            .subscribe(data => {

                this.copydays = data.Spotdays;
                this.spotdayView();

            }, erro => {

                this.util.alertResult(erro);

            });

    }

    spotdayQual(spotday) {
    
        if (!this.flagstor) this.spotdayOpen(spotday);
        if ( this.flagstor) this.spotdayKita(spotday);

    }

    spotdayOpen(spotday) {

        let object = {etapa: 0, spotdayID: spotday.SpotdayID};
        this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe();

    }

    spotdayKita(spotday) {

        let object = {etapa: 0, spotday: spotday};
        this.util.modalopen(SpotdayViewPage, 'alto', false, object).subscribe();

    }

    projetoMenu() {

        let onSave = (array) => {
            this.projetoLupa = array[0];
            this.spotdayView();
        };

        let objectPrj = {homeb: false, etapa: 0, title: null, keyname: 'Projeto', toggler: 'many', rootspot: this.rootspot};
        this.util.modalopen(WebstorOpenPage, 'alto', false, objectPrj).subscribe(data => onSave(data));

    }

    spotdayYear() {

        this.iondate.open();

    }

    spotdayView() {

        let prepareList = () => {

            this.spotdays = this.copydays.filter(SD => {
                return (!this.projetoLupa || SD.Projeto.ProjetoID == this.projetoLupa.ProjetoID) && SD.SpotdayDate.toString().substring(0, 4) == this.spotdayLupa
            });
        
        }

        setTimeout(() => prepareList(), 0);

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/spotday-list/spotday-list.ts